import {create} from "zustand";

export const useTestStore = create((set, get) => ({
    test:{},
    loadTest: (test) => set( () => ({test: test}))
}))
